module.exports = __webpack_public_path__ + "static/img/Uranus.5e70b4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Uranus.svg
// module id = 1418
// module chunks = 0